import { gql } from "@apollo/client";

export const CHECK_FOR_TBA_WARNINGS = gql`
  query checkForTbaWarnings($bookingId: String!) {
    checkForTbaWarnings(bookingId: $bookingId)
  }
`;